// src/api.js
import axios from 'axios';

const api = axios.create({

  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // if you are using cookies for auth
});

export default api;
